import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { GQLTextEngraving, GQLFont, GQLSide } from '@jewelutions/core-crm-server-api-client-domain';
import { Box } from '../../types-hack';

interface IProps {
  side: GQLSide;
  engraving: GQLTextEngraving;
  font: GQLFont;
}

const EngravingTextDetails: React.FC<IProps> = ({ side, engraving, font }: IProps) => {
  return (
    <Card style={{ width: 'fit-content' }}>
      <Box p={5}>
        <Typography component="span" variant={'h6'}>
          Text engraving : {engraving.text?.join(' / ')}
        </Typography>
        <Typography component="span" variant={'h6'}>
          Text font family : {font.name} & Text font size :
          {engraving.fontSize !== -1 ? engraving.fontSize : 'MAX'} & Text line spacing :
          {engraving.lineSpacing !== -1 ? engraving.lineSpacing : 'MAX'}
        </Typography>
        <Typography component="span" variant={'h6'}>
          Side : {side}
        </Typography>
      </Box>
    </Card>
  );
};

export default EngravingTextDetails;
